import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box, IconButton } from '@mui/material';
import type { SxProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { mergeSx } from '../../../../utils/styles';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
    backgroundColor: 'action.hover',
    borderRight: '1px solid',
    borderColor: 'divider',
  },
  button: {
    width: '100%',
    height: '100%',
    borderRadius: 0,
    color: 'text.secondary',
    backgroundColor: 'neutral.500',
    '&:hover': {
      backgroundColor: 'neutral.600',
    },
  },
} as const;

type NeobetRemoveRailProps = {
  onClick: () => void;
  ariaLabel?: string;
  testId?: string;
  sx?: SxProps<Theme>;
};

const NeobetRemoveRail = ({ onClick, ariaLabel, testId, sx }: NeobetRemoveRailProps) => (
  <Box sx={mergeSx(styles.root, sx)}>
    <IconButton size='small' sx={styles.button} onClick={onClick} aria-label={ariaLabel} data-testid={testId}>
      <CloseRoundedIcon fontSize='small' />
    </IconButton>
  </Box>
);

export default NeobetRemoveRail;
